/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import React from "react";
import EntityTable from "../common/EntityTable";

/*
 * Componente de especialización de EntityTable para edificios.
 * 
 * EntityTable (componente genérico)
 *      ↑
 * EdificiosTable (especialización para edificios)
 */
const EdificiosTable = () => {
  /*************************************************************
   * Renderizado del componente con configuración específica   *
   *************************************************************/
  return (
    /* 
     * EntityTable configurado para edificios
    */
    <EntityTable
      // Endpoint de la API REST para edificios
      endpoint="/edificios"
      title="Edificios"
      grid={true}
      showImage= {true}
      /* 
       * Campos personalizados para vista detalle
       */
      detailFields={[
        { label: "Dirección", value: (e) => e.direccion },
        { label: "Teléfono", value: (e) => e.telefono },
      ]}

      /* 
       * Renderizado personalizado para cada edificio
       */
      renderItem={(edificio) => {
        // Determinar URL de la imagen: foto específica o por defecto
        const url = edificio.fotoUrl
          ? `${process.env.REACT_APP_URL}${edificio.fotoUrl}`
          : `${process.env.REACT_APP_URL}/uploads/default-building.png`;

        // Identificar si es imagen por defecto para aplicar efectos
        const isDefault = !edificio.fotoUrl;

        return (
          /* Contenido de la tarjeta del edificio */
          <>
            {/* Imagen del edificio con efectos condicionales */}
            <img
              src={url}
              alt={edificio.nombre}
              className="card-img-top"
              style={{
                height: "150px",
                objectFit: "cover",
                filter: isDefault ? "blur(2px)" : "none",
              }}
            />

            {/* Cuerpo de la tarjeta con nombre del edificio */}
            <div className="card-body text-center">
              <h6 className="card-title fw-semibold mb-0">
                {edificio.nombre}
              </h6>
            </div>
          </>
        );
      }}
    />
  );
};

export default EdificiosTable;
